import { getDayJs } from '~/services/TimeService';

import { SuggestedActionType } from '../types';

export const SUGGESTED_ACTION_TYPE_OPTIONS: Array<{ value: SuggestedActionType; label: string }> = [
  { value: 'surcharge', label: 'Surcharge' },
  { value: 'discount', label: 'Discount' },
];

export function formatDate(value: string | null): string {
  if (!value) {
    return '—';
  }
  const parsed = getDayJs(value);
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : value;
}

export function formatDateTime(value: string | null): string {
  if (!value) {
    return '—';
  }
  const parsed = getDayJs(value);
  return parsed.isValid() ? parsed.format('DD/MM/YYYY HH:mm') : value;
}

export function getTourOfferHref(offerBk: string | null | undefined, offerUrl?: string | null): string | null {
  if (offerUrl) {
    return offerUrl;
  }
  const trimmedOfferBk = offerBk?.trim();
  if (!trimmedOfferBk) {
    return null;
  }
  return `${window.location.origin}/tours/details/tour-${trimmedOfferBk}`;
}

export function formatCurrency(value: number | null): string {
  if (value == null) {
    return '—';
  }
  return `$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatSignedPercent(value: number | null): string {
  if (value == null) {
    return '—';
  }
  const prefix = value > 0 ? '+' : '';
  return `${prefix}${(value * 100).toFixed(1)}%`;
}

export function formatSignedCurrency(value: number | null): string {
  if (value == null) {
    return '—';
  }
  const prefix = value > 0 ? '+' : '';
  return `${prefix}$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function getChangeColor(actionType: string): string {
  if (actionType === 'surcharge') {
    return 'success.main';
  }
  if (actionType === 'discount') {
    return 'error.main';
  }
  return 'text.primary';
}

export function getStatusColor(status: string): 'success' | 'error' | 'default' {
  if (status === 'accepted') {
    return 'success';
  }
  if (status === 'rejected') {
    return 'error';
  }
  return 'default';
}

export function capitalizeFirst(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
